import React, { RefObject } from 'react';

import { useHoveredMarkerContext } from 'entities/map';
import useStyles from './useStyles';

const Tooltip = (_: Props) => {
  const { hoveredMarker } = useHoveredMarkerContext();
  const classes = useStyles();

  if (!hoveredMarker || !hoveredMarker.station.code) return null;

  return (
    <span
      className={classes.container}
      style={{
        left: hoveredMarker.viewportCoords.x || 0,
        top: hoveredMarker.viewportCoords.y || 0
      }}
    >
      {hoveredMarker.station.code}
    </span>
  )
};

interface Props {
  containerRef: RefObject<HTMLDivElement>;
}

export default Tooltip;
